var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('el-drawer', {
    staticClass: "schema-manager",
    attrs: {
      "title": "高级搜索方案",
      "visible": _vm.value,
      "modal": false,
      "direction": "rtl"
    },
    on: {
      "close": _vm.handleClose
    }
  }, [_c('div', {
    staticClass: "label-tip el-color-gray-7"
  }, [_vm._v(" 置顶方案（将直接出现在搜索栏上） ")]), _c('schema-items', {
    attrs: {
      "schemas": _vm.fixedSchemas
    },
    on: {
      "save": _vm.handleSave,
      "del": _vm.handleDel
    }
  }), _c('div', {
    staticClass: "label-tip el-color-gray-7"
  }, [_vm._v(" 其他方案(" + _vm._s(_vm.otherSchemas.length) + ") ")]), _c('schema-items', {
    attrs: {
      "schemas": _vm.otherSchemas
    },
    on: {
      "save": _vm.handleSave,
      "del": _vm.handleDel
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };